// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d46ca03a","453":"b72887c7","455":"157f9391","977":"a097a52f"}[chunkId] + ".chunk.js";
};